module.exports = "/_next/static/images/SubjectRightsManagement-afaf2efc172bac547014a091b73cbbc8.webp";